import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme, useMediaQuery } from '@mui/material'
import { Select } from '@center/ui-kit'
import { 
  DropdownIndicator, 
  ValueContainer, 
  CustomOption, 
  CustomControl, 
  getSelectStyles 
} from 'components/global/Selects/SingleSelectStyles'

export interface MonthSelectChoice {
  label: string
  value: string
  id: number
}

interface MonthSelectProps {
  onMonthSelect: (date: Date) => void
  startDate: Date
  endDate: Date
}

const MonthSelect: React.FC<MonthSelectProps> = ({ onMonthSelect, startDate, endDate }) => {
  const { i18n } = useTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [selectedOption, setSelectedOption] = useState<MonthSelectChoice | null>(null)
  
  const getMonthOptions = (): MonthSelectChoice[] => {
    const options: MonthSelectChoice[] = []
    const monthDiff = (endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth())
    
    for (let i = 0; i <= monthDiff; i++) {
      const currentDate = new Date(endDate)
      currentDate.setMonth(currentDate.getMonth() - i)
      
      const month = currentDate.toLocaleDateString(i18n.language, { month: 'long' })
      const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1)
      const year = currentDate.getFullYear()
      
      options.push({
        label: `${capitalizedMonth} ${year}`,
        value: `${year}-${currentDate.getMonth()}`,
        id: i
      })
    }
    
    return options
  }

  const handleChange = (selected: MonthSelectChoice) => {
    setSelectedOption(selected)
    const [year, month] = selected.value.split('-')
    onMonthSelect(new Date(parseInt(year), parseInt(month)))
  }

  return (
    <Select
      value={selectedOption || getMonthOptions()[0]}
      onChange={handleChange}
      options={getMonthOptions()}
      mainField={'label'}
      components={{ 
        Option: CustomOption,
        DropdownIndicator,
        ValueContainer,
        Control: CustomControl,
        IndicatorSeparator: () => null,
        ClearIndicator: () => null
      }}
      menuPortalTarget={document.body}
      styles={getSelectStyles(theme, isMobile)}
    />
  )
}

export default MonthSelect
